module.exports = __webpack_public_path__ + "img/icon_forward_simple_yellow.a6f3d0c7.svg";